import { createApi } from "@reduxjs/toolkit/query/react"
import { customBaseQuery } from "./base-query"

const tagTypes = [
  "Billing",
  "Board",
  "CalendarEvent",
  "ContextOptions",
  "EmailChangeRequest",
  "Holiday",
  "HourReport",
  "HourReportSettings",
  "HourReportAdmins",
  "HourReportAuditableMembership",
  "HourReportDayAudit",
  "HourReporterMembership",
  "Link",
  "NavItems",
  "Options",
  "Organisation",
  "Project",
  "ProjectDashboard",
  "ProjectPermission",
  "ProjectType",
  "ProjectsDashboard",
  "Reminder",
  "StorageFile",
  "Task",
  "TaskPermission",
  "Todo",
  "User",
  "Chat",
  "ChatUnread",
  "Message",
  "ChatRead",
] as const
export type TagType = (typeof tagTypes)[number]

export const api = createApi({
  reducerPath: "api",
  tagTypes,
  baseQuery: customBaseQuery,
  endpoints: () => ({}),
})
